import { Injectable } from "@angular/core";
import { StorageService } from "./storage.service";
@Injectable({
  providedIn: 'root'
})
export class LocalService extends StorageService {
  constructor() {
    super(window.sessionStorage);
  }
}
